export const BathroomIcon = () => (
  <svg viewBox="0 0 460 460" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32px">
    <g>
      <path d="M417.74 247.94v95.43c0 37.52-30.74 67.93-68.66 67.93H122.3c-37.92 0-68.66-30.41-68.66-67.93v-38.92" />
      <path d="M438.45 225.93a21.45 21.45 0 0 1-15.87 20.67l-107.31 29.6a55.6 55.6 0 0 1-14.74 2H41a21.54 21.54 0 1 1 0-43.07h255.37a55.39 55.39 0 0 0 14.93-2.05l99.48-27.82a21.86 21.86 0 0 1 26.9 14.74 20.9 20.9 0 0 1 .77 5.93ZM169.29 411.3v20c0 7.06-7 12.78-15.54 12.78h-8.81c-8.59 0-15.54-5.72-15.54-12.78v-20M330.91 411.3v20c0 7.06-7 12.78-15.54 12.78h-8.81c-8.59 0-15.55-5.72-15.55-12.78v-20" />
      <path d="M296.88 89.08v-24a39.87 39.87 0 0 1 39.87-39.87h0a39.88 39.88 0 0 1 39.88 39.87v149.3M330.76 89.1h-66.3" />
    </g>
  </svg>
);
